import styled from 'styled-components'
import { DropdownItem, tokens } from '@arvoreeducacao/bonsai-ds'

export const Page = styled.div`
  position: relative;
  background-color: ${tokens.colors.white};

  padding: 50px 0px;

  min-height: 80vh;
  margin: -20px 30px;
`

export const Hr = styled.hr`
  border-top: 0px solid ${tokens.colors.dark2};
`

export const DropdownItemStyled = styled(DropdownItem)`
  color: ${tokens.colors.dark5};

  span {
    color: ${tokens.colors.dark5};
  }
`
